export const kodeAkunFilter = (dropdownSubCategory) => {
  return [
    {
      id: "id_akun_sub_kategori",
      label: "Sub Kategori",
      options: dropdownSubCategory,
    },
  ];
};
